import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end w-full px-56 pr-80 mgb-16" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl" }, null, -1)
const _hoisted_3 = { class: "table-role-list w-full px-56 pr-80" }
const _hoisted_4 = { class: "flex justify-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "flex justify-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "icon-tooltip" }
const _hoisted_9 = { class: "tooltiptext" }
const _hoisted_10 = { class: "icon-tooltip" }
const _hoisted_11 = { class: "tooltiptext" }
const _hoisted_12 = { class: "icon-tooltip" }
const _hoisted_13 = { class: "tooltiptext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PermissionSetting = _resolveComponent("PermissionSetting")
  const _component_Button = _resolveComponent("Button")
  const _component_Table = _resolveComponent("Table")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_PermissionSetting),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleAddPermissions,
        class: "btn-outline-blue h-12"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.t('addPermissions')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Table, {
        data: _ctx.roleData,
        headers: _ctx.roleListHeaders
      }, {
        permission_code: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, _toDisplayString(item.role_code), 1)
          ])
        ]),
        authority_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(item.role_name), 1)
          ])
        ]),
        edit: _withCtx(({ item }) => [
          _createVNode("div", {
            class: ["flex items-center justify-center", 
            item.id === _ctx.ROLES_DEFAULT.ID
              ? 'pointer-events-none cursor-default'
              : ''
          ]
          }, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.t('actionEdit')), 1),
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.handleUpdatePermissions(item)),
                class: "cp-icon-edit-square text-2xl hover:text-blue-600 cursor-pointer text-gray-333"
              }, null, 8, ["onClick"])
            ])
          ], 2)
        ]),
        delete: _withCtx(({ item }) => [
          _createVNode("div", {
            class: ["flex items-center justify-center", 
            item.id === _ctx.ROLES_DEFAULT.ID
              ? 'pointer-events-none cursor-default'
              : ''
          ]
          }, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.t('actionDelete')), 1),
              _createVNode("span", {
                class: "cp-icon-trash text-2xl hover:text-blue-600 cursor-pointer",
                onClick: ($event: any) => (_ctx.handleDeleteItem(item))
              }, null, 8, ["onClick"])
            ])
          ], 2)
        ]),
        copy: _withCtx(({ item }) => [
          _createVNode("div", {
            class: ["flex items-center justify-center", 
            item.id === _ctx.ROLES_DEFAULT.ID
              ? 'pointer-events-none cursor-default'
              : ''
          ]
          }, [
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, _toDisplayString(_ctx.t('actionCopy')), 1),
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.handleCopyItem(item)),
                class: "cp-icon-copy text-2xl hover:text-blue-600 cursor-pointer"
              }, null, 8, ["onClick"])
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["data", "headers"])
    ])
  ], 64))
}